export default class Modals {
    initialize() {
        this.closeMessagePrompt();
        this.closeApprovedPrompt();
    }

    closeMessagePrompt() {
        Livewire.on('allowCloseMessagePrompt', event => {
            // Close on click outside
            $(document).on("click", function(event){
                var $trigger = $("#first_message_helper_prompt .modal-content");

                if($trigger !== event.target && !$trigger.has(event.target).length){
                    $("#first_message_helper_prompt").removeClass('show');
                    Livewire.emit('closeMessagePrompt');
                }            
            });
        });
    }

    closeApprovedPrompt() {
        Livewire.on('allowCloseApprovedPrompt', event => {
            // Close on click outside
            $(document).on("click", function(event){
                var $trigger = $("#approved_connection_helper_prompt .modal-content");

                if($trigger !== event.target && !$trigger.has(event.target).length){
                    Livewire.emit('markAsViewed');
                }            
            });
        });
    }
}